import React from "react";
import { OrderContext } from "./OrderProvider";

export default function OrderInformation() {
  const { state, dispatch } = React.useContext(OrderContext);
  React.useEffect(() => {
    // Shows
    fetch(`${process.env.REACT_APP_ODATA_BASE_URL}Shows`)
      .then((res) => res.json())
      .then((data) => {
        const availableShows = data.value.filter(
          (showAvailable) =>
            showAvailable.seats_available !== 0 &&
            showAvailable.number_of_seats > 0
        );
        const uniqueSeats = availableShows.filter(
          (seat, index, self) =>
            index ===
            self.findIndex(
              (s) =>
                s.show_location === seat.show_location &&
                s.show_date === seat.show_date
            )
        );
        // const uniqueSeatsTime = data.value.filter(
        //   (seat, index, self) =>
        //     index ===
        //     self.findIndex(
        //       (s) =>
        //         s.show_date === seat.show_date && s.show_time === seat.show_time
        //     )
        // );
        dispatch({ type: "SET_ALL_SEATS", value: data.value });
        dispatch({ type: "SET_SEATS", value: uniqueSeats });
        // dispatch({ type: "SET_SEATS_TIME", value: uniqueSeatsTime });
      })
      .catch((err) => {
        console.error("Error fetching seats:", err);
        dispatch({
          type: "SET_SEATS",
          value: [
            {
              show_id: "SH001",
              show_date: "2023-10-01",
              show_time: "10:00 AM",
              seat_price: 300,
              seat_type: "ST001",
              show_location: "JMR Coliseum",
            },
            {
              show_id: "SH001",
              show_date: "2023-10-02",
              show_time: "10:00 PM",
              seat_price: 150,
              seat_type: "ST002",
              show_location: "JMR Coliseum",
            },
          ],
        });
      });
    // Seat Types
    fetch(`${process.env.REACT_APP_ODATA_BASE_URL}SeatTypes`)
      .then((res) => res.json())
      .then((data) => {
        dispatch({ type: "SET_SEAT_TYPES", value: data.value });
      })
      .catch((err) => {
        dispatch({
          type: "SET_SEAT_TYPES",
          value: [
            { seat_type: "ST001", seat_type_desc: "VIP", seat_price: 300 },
            { seat_type: "ST002", seat_type_desc: "Regular", seat_price: 150 },
          ],
        });
      });
    // Discount Types
    fetch(`${process.env.REACT_APP_ODATA_BASE_URL}DiscountTypes`)
      .then((res) => res.json())
      .then((data) =>
        dispatch({ type: "SET_DISCOUNT_TYPES", value: data.value })
      )
      .catch((err) => {
        dispatch({
          type: "SET_DISCOUNT_TYPES",
          value: [
            { discount_type_id: "DT001", discount_description: "Student ID" },
            {
              discount_type_id: "DT002",
              discount_description: "Senior Citizen",
            },
            { discount_type_id: "DT003", discount_description: "PWD" },
          ],
        });
      });
    // Payment Methods
    fetch(`${process.env.REACT_APP_ODATA_BASE_URL}PaymentMethods`)
      .then((res) => res.json())
      .then((data) =>
        dispatch({ type: "SET_PAYMENT_METHODS", value: data.value })
      )
      .catch((err) => {
        dispatch({
          type: "SET_PAYMENT_METHODS",
          value: [
            { payment_method_id: "PM001", payment_description: "GCash" },
            {
              payment_method_id: "PM002",
              payment_description: "PayMaya",
            },
            { payment_method_id: "PM003", payment_description: "BPI" },
            { payment_method_id: "PM004", payment_description: "Cash" },
          ],
        });
      });
  }, [dispatch]);

  function calculateTotalAmount(seatType, state) {
    dispatch({
      type: "SET_SELECTED_SEAT_TYPE",
      value: seatType,
    });
    const selectedSeat = state.seatTypes.find(
      (seat) => seat.seat_type === seatType
    );
    var totalAmount;
    if (state.selectedDiscountType !== "DT000" && state.selectedDiscountType) {
      totalAmount = state.selectedQuantity * selectedSeat.seat_price * 0.8;
    } else {
      totalAmount = state.selectedQuantity * selectedSeat.seat_price;
    }
    dispatch({
      type: "SET_SELECTED_SEAT_PRICE",
      value: selectedSeat.seat_price,
    });
    dispatch({ type: "SET_TOTAL_AMOUNT", value: totalAmount });
  }
  function handleDiscountTypeChange(e, state) {
    dispatch({
      type: "SET_SELECTED_DISCOUNT_TYPE",
      value: e.target.value,
    });
    if (state.selectedSeatType) {
      calculateTotalAmount(state.selectedSeatType, state);
    }
  }
  function handlePaymentMethodChange(e, state) {
    dispatch({
      type: "SET_SELECTED_PAYMENT_METHOD",
      value: e.target.value,
    });
    if (state.selectedSeatType) {
      calculateTotalAmount(state.selectedSeatType, state);
    }
  }
  return (
    <div style={{ marginBottom: "" }}>
      <input
        type="hidden"
        name="show_id"
        value={state.selectedSeat.show_id || ""}
      />
      <input type="hidden" name="availability" value="R" />
      <p className="main-form-headerLabel">II. Booking Information</p>
      <label htmlFor="show_date" className="main-form-label">
        Show Date <span style={{ color: "red" }}>*</span>
      </label>
      <select
        id="show_date"
        name="show_date"
        className="main-form-input"
        value={state.selectedSeat.show_date || ""}
        onChange={(e) => {
          const found = state.seats.find(
            (seat) => seat.show_date === e.target.value
          );
          const timeForDate = state.seats
            .filter((s) => s.show_date === e.target.value)
            .filter(
              (seat, index, self) =>
                index === self.findIndex((s) => s.show_time === seat.show_time)
            );
          // const seatTypeForDate = state.seats
          //   .filter((s) => s.show_date === e.target.value)
          //   .filter(
          //     (seat, index, self) =>
          //       index === self.findIndex((s) => s.seat_type === seat.seat_type)
          //   );
          dispatch({ type: "SET_SELECTED_SEAT", value: found || {} });
          dispatch({ type: "SET_SEATS_TIME", value: timeForDate });
          // dispatch({ type: "SET_SEAT_TYPES", value: seatTypeForDate });
        }}
        required
      >
        <option value="" disabled selected hidden>
          Select Show date
        </option>
        {state.uniqueSeats.map((seat) => (
          <option key={seat.show_date} value={seat.show_date}>
            {new Date(seat.show_date).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}{" "}
            - {seat.show_location}
          </option>
        ))}
      </select>
      <label htmlFor="show_time" className="main-form-label">
        Show Time <span style={{ color: "red" }}>*</span>
      </label>
      <select
        id="show_time"
        name="show_time"
        className="main-form-input"
        disabled={!state.selectedSeat.show_date}
        value={state.selectedSeat.show_time || ""}
        onChange={(e) => {
          const found = state.seats.find(
            (seat) =>
              seat.show_time === e.target.value &&
              seat.show_date === state.selectedSeat.show_date
          );
          dispatch({ type: "SET_SELECTED_SEAT", value: found || {} });
        }}
        required
      >
        <option value="" disabled selected hidden>
          Select Show time{" "}
        </option>
        {state.seatsTime.map((seat) => (
          <option key={seat.show_time} value={seat.show_time}>
            {seat.show_time}
          </option>
        ))}
      </select>

      {state.orderType === "1" ? (
        <>
          {" "}
          <label htmlFor="seat_type" className="main-form-label">
            Seat Type <span style={{ color: "red" }}>*</span>
          </label>
          <select
            id="seat_type"
            name="seat_type"
            className="main-form-input"
            value={state.selectedSeatType}
            disabled={!state.selectedSeat.show_date}
            onChange={(e) => {
              calculateTotalAmount(e.target.value, state);
              if (e.target.value === "ST001") {
                dispatch({
                  type: "SET_SELECTED_DISCOUNT_TYPE",
                  value: "DT000", // Fixed value for discount type when seat type is ST001
                });
              }
            }}
            required
          >
            <option value="" disabled selected hidden>
              Select Seat Type
            </option>
            {state.seatTypes.map((seatType) => (
              <option key={seatType.seat_type} value={seatType.seat_type}>
                {seatType.seat_type_desc} - {seatType.seat_price}
              </option>
            ))}
          </select>
          {/* Promo Code */}
          {state.selectedSeatType === "ST001" && (
            <>
              <label htmlFor="promo_code" className="main-form-label">
                Promo Code
              </label>
              <input
                type="text"
                id="promo_code"
                name="promo_code"
                className="main-form-input"
              />
            </>
          )}
        </>
      ) : (
        <>
          {" "}
          <label htmlFor="quantity" className="main-form-label">
            Quantity <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="number"
            id="quantity"
            name="quantity"
            placeholder="Total Number of Seats to book"
            required
            min={30}
            value={state.selectedQuantity}
            onChange={(e) => {
              dispatch({
                type: "SET_SELECTED_QUANTITY",
                value: e.target.value,
              });
            }}
            className="main-form-input"
          />
          {/* Default payment method to PM004/Cash if order type  is 2 */}
          <input
            type="hidden"
            id="payment_method"
            name="payment_method"
            value="PM004"
          />
        </>
      )}
      {state.orderType === "1" ? (
        <>
          <label htmlFor="discount_type" className="main-form-label">
            Discount Type
          </label>
          <select
            id="discount_type"
            name="discount_type"
            className="main-form-input"
            value={state.selectedDiscountType}
            onChange={(e) => handleDiscountTypeChange(e, state)}
            disabled={state.selectedSeatType === "ST001"}
          >
            <option value="DT000" disabled selected hidden>
              Select Discount
            </option>
            <option value="DT000" id="DT000">
              {" "}
              {/* No discount option */}
              None
            </option>
            {state.discountTypes.map((dt) => (
              <option key={dt.discount_type_id} value={dt.discount_type_id}>
                {dt.discount_description}
              </option>
            ))}
          </select>
          {state.selectedDiscountType !== "DT000" &&
          state.selectedDiscountType !== "" ? (
            <DiscountTypesAttachment />
          ) : null}
        </>
      ) : null}

      <label htmlFor="payment_method" className="main-form-label">
        Payment Method <span style={{ color: "red" }}>*</span>
      </label>
      <select
        id="payment_method"
        name="payment_method"
        className="main-form-input"
        value={state.orderType === "2" ? "PM004" : state.selectedPaymentMethod}
        disabled={state.orderType === "2"}
        onChange={(e) => handlePaymentMethodChange(e, state)}
        required
      >
        <option value="" disabled selected hidden>
          Select Payment Method
        </option>
        {state.paymentMethods.map((pt) => (
          <option key={pt.payment_method_id} value={pt.payment_method_id}>
            {pt.payment_description}
          </option>
        ))}
      </select>
      {state.orderType === "1" ? (
        <div
          style={{
            marginTop: "10px",
            marginBottom: "10px",
            display: "flex",
            flexDirection: "column",
            width: "fit-content",
            // alignItems: "left",
          }}
        >
          <label htmlFor="isgeneratepdfticket" className="main-form-label">
            I want an e-ticket
          </label>
          <input
            type="checkbox"
            id="isgeneratepdfticket"
            name="isgeneratepdfticket"
            style={{
              width: "20px",
              height: "20px",
              marginTop: "5px",
              marginBottom: "10px",
            }}
            // checked={state.isgeneratepdfticket}
            // onChange={(e) => {
            //   dispatch({
            //     type: "SET_IS_GENERATE_PDF_TICKET",
            //     value: e.target.checked,
            //   });
            // }}
          />
        </div>
      ) : null}
      {state.orderType === "1" &&
      state.selectedPaymentMethod !== "" &&
      state.selectedPaymentMethod !== "PM004" ? (
        <PaymentMethods paymentMethod={state.selectedPaymentMethod} />
      ) : state.orderType === "2" || state.selectedPaymentMethod === "PM004" ? (
        <>
          <i style={{ color: "#7d3f26", fontSize: "13px" }}>
            Note: For Cash payers: Please present your Order ID generated at the
            Show Location
          </i>
          <br />
          <i style={{ color: "#7d3f26", fontSize: "13px" }}>
            Location:{" "}
            {state.selectedSeat?.show_location ||
              "(Choose a date/location first)"}{" "}
            - Look for Ma'am Ying
          </i>
        </>
      ) : null}
      {state.totalAmount > 0 && state.orderType === "1" ? (
        <TotalAmount state={state} />
      ) : null}
    </div>
  );
}

function DiscountTypesAttachment() {
  function handleFileChange(event) {
    const file = event.target.files[0];
    if (file) {
      // Validate file type and size if necessary
      const validTypes = ["image/jpeg", "image/png", "application/pdf"];
      if (!validTypes.includes(file.type)) {
        alert("Invalid file type. Please upload a JPG, PNG, or PDF file.");
        event.target.value = ""; // Reset the input
      } else if (file.size > 5 * 1024 * 1024) {
        // 5MB limit
        alert("File size exceeds 5MB. Please upload a smaller file.");
        event.target.value = ""; // Reset the input
      }
    }
  }
  return (
    <>
      {" "}
      <label htmlFor="discount_attachment" className="main-form-label">
        Discount ID Attachment <span style={{ color: "red" }}>*</span>
      </label>
      <input
        type="file"
        id="discount_attachment"
        name="discount_attachment"
        accept=".jpg,.jpeg,.png,.pdf"
        required
        className="main-form-input"
        onChange={handleFileChange}
      />
    </>
  );
}

function PaymentMethods({ paymentMethod }) {
  const [copied, setCopied] = React.useState(false);

  function handleCopyNumber(paymentMethod) {
    navigator.clipboard.writeText(
      paymentMethod === "PM001"
        ? process.env.REACT_APP_GCASH_NUMBER
        : paymentMethod === "PM002"
        ? process.env.REACT_APP_PAYMAYA_NUMBER
        : process.env.REACT_APP_BPI_ACCOUNT
    );
    setCopied(true);
    console.log("Copied to clipboard:", copied);
    alert("Copied to clipboard!");
    setTimeout(() => {
      setCopied(false);
    }, 2000); // Reset copied state after 2 seconds
  }
  return (
    <>
      {" "}
      <center style={{ padding: "20px" }}>
        <img
          src={require(`../assets/payments-qrcodes/${paymentMethod}.png`)}
          alt={`${paymentMethod}.png`}
          style={{ width: "200px", height: "200px" }}
        />
      </center>
      <div
        onClick={() => {
          handleCopyNumber(paymentMethod);
        }}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          color: "#7d3f26",
          fontSize: "15px",
          marginBottom: "20px",
          fontWeight: "bold",
        }}
      >
        <img
          src={require("../assets/copy_btn.png")}
          alt="info"
          style={{ width: "50px", height: "20px" }}
        />
        <span>Click to copy</span>
      </div>
      <label htmlFor="reference_number" className="main-form-label">
        Reference Number <span style={{ color: "red" }}>*</span>
      </label>
      <input
        type="text"
        id="reference_number"
        name="reference_number"
        placeholder="Enter reference number"
        required
        className="main-form-input"
        maxLength="15"
      />
    </>
  );
}

function TotalAmount({ state }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: "20px",
        marginBottom: "20px",
      }}
    >
      <h3 style={{ fontWeight: "bold", color: "#7d3f26" }}>Total Amount:</h3>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
      >
        <span>{state.selectedSeatPrice} </span>
        <span>x {state.selectedQuantity}</span>
        <span>___________________</span>
        <span style={{ fontWeight: "bold", fontSize: "20px" }}>
          P{state.totalAmount}
        </span>
        {state.selectedDiscountType !== "DT000" && (
          <span style={{ color: "red", fontSize: "14px" }}>
            (Discount Applied)
          </span>
        )}
      </div>
    </div>
  );
}
